import clsx from 'clsx';

const PositionCardLoading: React.FC<{ slimmed?: boolean }> = ({ slimmed }) => (
  <div
    className={clsx('bg-background flex flex-col overflow-hidden rounded-2xl shadow-xl lg:flex-row', slimmed ? 'h-[180px]' : 'h-[320px]')}>
    {!slimmed && (
      <div className='flex flex-none overflow-hidden'>
        <div className={clsx('relative w-full overflow-hidden lg:h-auto lg:w-80', slimmed ? 'h-20' : 'h-40')}>
          <div className='h-full w-full'>
            <div className='col-span-2 h-full animate-pulse rounded-sm bg-gray-200' />
          </div>
        </div>
      </div>
    )}
    <div className='h-full w-full'>
      <div className='flex h-full w-full justify-between'>
        <div className='mt-4 h-8 w-8/12 px-5'>
          <div className='col-span-2 h-full animate-pulse rounded-sm bg-gray-200' />
        </div>

        <div className='mt-4 h-8 w-4/12 px-5'>
          <div className='col-span-2 h-full animate-pulse rounded-sm bg-gray-200' />
        </div>
      </div>
      {!slimmed && (
        <>
          <div className='mt-4 h-8 w-full px-5'>
            <div className='col-span-2 h-full animate-pulse rounded-sm bg-gray-200' />
          </div>

          <div className='mt-4 h-8 w-full px-5'>
            <div className='col-span-2 h-full animate-pulse rounded-sm bg-gray-200' />
          </div>

          <div className='mt-4 h-8 w-full px-5'>
            <div className='col-span-2 h-full animate-pulse rounded-sm bg-gray-200' />
          </div>

          <div className='mt-4 h-8 w-full px-5'>
            <div className='col-span-2 h-full animate-pulse rounded-sm bg-gray-200' />
          </div>
        </>
      )}
    </div>
  </div>
);

export default PositionCardLoading;
